import React from 'react';

import { profileClose } from '../uiFunctions/uiActions';



export class CloseProfile extends React.Component {
	constructor(props) {
		super(props);

		this.handleClose = this.handleClose.bind(this);
		this.handleDup = this.handleDup.bind(this);
	}

	handleClose() {
		profileClose();
		if (this.props.reset) {
			this.props.reset();
		}
	}
	handleDup() {
		profileClose();
		this.props.duplicate();
	}

	render() {

		let duplicate = this.props.duplicate;

		return(
			<div className="profile-close-wrap">
				<i className="fas fa-times icon" onClick={this.handleClose}></i>
				{(duplicate) && (
					<i className="fas fa-copy icon duplicate" onClick={this.handleDup}></i>
				)}
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/CloseProfile.js